// ============================================================================
// LES MOYENS QU'UN CLIENT ANNONCE POUR UNE ÉCHÉANCE — le code que la caisse écrit, le mot qui le lit.
//
// La caisse range dans `payment_reminder.expected_method` un CODE (`check`, `card`…) : une annonce, pas un
// règlement. Le siège et la caisse doivent le nommer de la même façon ; sans table commune, le back-office
// affichait le code brut (« check annoncé ») et la caisse oubliait `other`.
//
// ⚠️ CE NE SONT PAS LES MOYENS DE RÈGLEMENT DU RÉFÉRENTIEL (`CB`, `ESP`, `CHQ`…) : une échéance annonce une
//    intention de paiement, ses codes sont ceux du formulaire de la caisse — persistés, donc jamais renommés.
// ⚠️ DU FRANÇAIS, QUI EST LA CLÉ : le back-office le traduit au rendu (`audit-textes-partages` le surveille) ;
//    ce paquet n'embarque aucun moteur de traduction, la caisse l'affiche tel quel.
// ============================================================================

/** Le mot de la plateforme pour chaque code annoncé. */
export const REMINDER_METHOD_TEXT = {
  check: 'Chèque',
  card: 'CB',
  cash: 'Espèces',
  voucher: 'Avoir',
  transfer: 'Virement',
  other: 'Autre moyen',
} as const satisfies Readonly<Record<string, string>>;

export type ReminderMethod = keyof typeof REMINDER_METHOD_TEXT;

/**
 * Le mot d'un code annoncé — `null` pour un code inconnu, que l'appelant montre alors tel quel plutôt que
 * d'inventer un nom (un code venu d'une caisse plus récente reste lisible).
 */
export function reminderMethodText(code: string | null | undefined): string | null {
  if (!code) return null;
  return Object.hasOwn(REMINDER_METHOD_TEXT, code) ? REMINDER_METHOD_TEXT[code as ReminderMethod] : null;
}
